export default "__VITE_ASSET__BpPtjzBt__"